import React from 'react'
import DetailContainer from '../MainPage/common/DetailContainer'
import { images } from '../common/images';

function PowerDetailContainer({ phaseLoadLogs, phaseWiseData, phase, deviceId, phaseInName = true, live = true }) {

    // Find the last valid log that doesn't have the 'ct' key which means that log will be of 'disconnect' type
    const validPhaseData = phaseWiseData.filter(log => !log.hasOwnProperty('ct')).sort((a, b) => a.ts - b.ts);
  
    // Check if there is a valid log to display
    const lastValidLog = validPhaseData.length > 0 ? validPhaseData[validPhaseData.length - 1] : null;

  return (
    <DetailContainer
      name={`Power${phaseInName && Object.keys(phaseLoadLogs[deviceId]).length > 1 ? ` ${Number(phase) + 1}` : ''}`}
      value={`${(lastValidLog
        ? lastValidLog.p
        : 0
      ).toFixed(2)} W`}
      time={
        Object.keys(phaseLoadLogs)?.length !== 0 &&
          lastValidLog!==null
          ? lastValidLog.ts
          : new Date().getTime()
      }
      hasLog={lastValidLog !== null}
      reading
      live={live}
      color={"rgba(32, 80, 255, 0.10)"}
      borderColor={"#EF4444"}
      image={images.chartPower}
    />
  )
}

export default PowerDetailContainer